export default "__VITE_ASSET__tZDYVCBf__"